export const transition = {
    duration: 0.20,
    ease: [0.60, 0.60, 0.60, 0.60]
};
